/**
 * Bug #438
 * @Author Anupama P
 * @Date 1 Jul 2021
 **/

import { queryBreadCrumbLayout } from "client/client-router/Utils";
import { faArrowLeft, FontAwesomeIcon, Row, Title, Wrapper, useHistory } from "components";
import { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import style from './style/backArrowHeader.module.scss';

interface Path {
  label: string,
  url: string,

}

interface Props {
  title: string,
  paths?: Array<Path>,
}

function BreadCrumb(props) {
  const [breadCrumbData, setBreadCrumbData] = useState(null);
  const history = useHistory();

  useEffect(() => {
    const pathData = queryBreadCrumbLayout(props?.location?.pathname);
    if (pathData !== breadCrumbData) {
      setBreadCrumbData(pathData);
    }
  }, [props?.location?.pathname])

  return (
    /** Bug#692 @Author: Linda Susan Raju @Date: 22 Feb 2022*/
    <>
    {breadCrumbData && (breadCrumbData?.label || breadCrumbData?.breadCrumb?.showBackArrow) && <Wrapper className="sec-header" >
      <Row className={`${style.backArrowHeaderWidgetContainerLess}`}>
        {breadCrumbData?.breadCrumb?.showBackArrow && <FontAwesomeIcon icon={faArrowLeft} style={{fontSize:'16px', color:'#9e9e9e'}} className={`${style.backArrowBreadcrumb} ml-3`} 
        onClick={() => { history.goBack() }} />}
        <Title level={2} className="ml-3" >{breadCrumbData?.label}</Title>
      </Row>
      {/* style={{ color: (breadCrumbData?.breadCrumb?.isBackarrow) ? '#272b41' : '#6574cf' }}  */}
      {/*<Wrapper className="breadcrumb-bar">
       <Wrapper className="container-fluid">
         <Wrapper className="row align-items-center">
        <Wrapper className="col-md-12 col-12">*/}
      {
        /**
        * Bug #475
        * @Author Anish Chandran
        * @Date 3 July 2021
        **/
      }
      {/*<h2 className="breadcrumb-title"> {breadCrumbData?.label}</h2>*/}
      {/* {breadCrumbData?.breadCrumb? 
             <nav aria-label="breadcrumb" className="page-breadcrumb">
               <ol className="breadcrumb">
                 <li className="breadcrumb-item">
                   <a href="/home">Home</a>
                 </li>
                 {breadCrumbData[0]?.breadCrumb?.map((path, index) =>
                   <li className="breadcrumb-item active" aria-current="page" key={index}>
                     <a href={path.url}>{path.label}</a>
                   </li>
                 )}
                 <li className="breadcrumb-item active" aria-current="page">
                   {breadCrumbData?.label}
                 </li>
               </ol>
             </nav>:''
            } */}
      {/** End **/}
      {/*</Wrapper>
         </Wrapper>
       </Wrapper>
           </Wrapper>*/}
    </Wrapper>
    }
    </>
  )
}

export default withRouter(BreadCrumb)
 /** End */
